import AdminContainer from '../../Utility/AdminContainer';
import { PencilSimpleIcon } from '@phosphor-icons/react';
import useGroups from '../../../Hooks/useGroups';
import AdminBox from '../../Utility/AdminBox';
import AdminViewHeader from '../../Utility/AdminViewHeader';
import AdminViewContent from '../../Utility/AdminViewContent';
import { Group } from '../../../Types';
import { PaginationListType } from '../../../Types/PaginationParams';
import { groupService } from '../../../Services/groupService';
import PaginatedView from '../../Utility/PaginatedView';

function Groups() {
    const { GroupsActions, i18n, settings, getBreakpoint, windowWidth, handleNavigate } = useGroups();
    const GRID_COLS = 'grid-cols-[minmax(157px,300px),minmax(157px,200px),minmax(157px,200px),minmax(157px,1fr)]';

    const handleEdit = (identifier: string) => {
        GroupsActions.handleEdit(identifier);
    };
    return (
        <div className={`admin-container flex relative flex-col`}>
            <AdminContainer>
                <AdminBox classString="px-4">
                    <PaginatedView
                        listType={PaginationListType.Groups}
                        itemsFunction={groupService.getGroupsByPage}
                        itemsPerPage={15}
                        renderItem={(group: Group, index: number) => (
                            <AdminViewContent
                                key={group.identifier}
                                mobile={windowWidth < getBreakpoint('md')}
                                identifier={group.identifier}
                                gridCols={GRID_COLS}
                                cols={{
                                    optionalCols: [
                                        {
                                            content: group.title,
                                        },
                                        {
                                            content: `${group.usersCount} ${i18n.translate({
                                                id: 'users',
                                                sourceName: 'Groups',
                                            })}`,
                                        },
                                        {
                                            content: group.mandant,
                                            image: '/img/logos/entra.png',
                                            showImageMobile: false,
                                        },
                                    ],
                                    button: {
                                        buttons: [
                                            {
                                                variant: 'primaryRound',
                                                onClick: () => handleEdit(group.identifier),
                                                icon: <PencilSimpleIcon />,
                                            },
                                        ],
                                    },
                                    mobileOrder: {
                                        main: group.title,
                                        optionalCols: [
                                            `${group.usersCount} ${i18n.translate({
                                                id: 'users',
                                                sourceName: 'Groups',
                                            })}`,
                                            group.mandant,
                                        ],
                                    },
                                }}
                            />
                        )}
                    >
                        {({ list, filter }) => (
                            <>
                                {filter}
                                <div className="hidden md:block">
                                    <AdminViewHeader
                                        gridCols={GRID_COLS}
                                        cols={{
                                            cols: [
                                                {
                                                    text: i18n.translate({
                                                        id: 'adminHeader.mainCol',
                                                        sourceName: 'Main',
                                                    }),
                                                },
                                                {
                                                    text: i18n.translate({
                                                        id: 'card.usersCount',
                                                        sourceName: 'Groups',
                                                    }),
                                                },
                                                {
                                                    text: i18n.translate({ id: 'card.client', sourceName: 'Groups' }),
                                                },
                                            ],
                                            button: {
                                                text: i18n.translate({ id: 'newGroup.button', sourceName: 'Groups' }),
                                                function: () => handleNavigate('new'),
                                                renderCondition: settings.localGroups,
                                            },
                                        }}
                                    />
                                    <hr className="border-layout-borderColor mt-5" />
                                </div>
                                {list}
                            </>
                        )}
                    </PaginatedView>
                </AdminBox>
            </AdminContainer>
        </div>
    );
}

export default Groups;
